import { ChildModel, ModelBase } from 'store/model-base';
import { PendingLineTransfer } from './pending-line-transfer';

export class PendingLineTransferCollection extends ModelBase {
    public static storeName: string = 'pendingLineTransferCollection';
    
    public pendingLineTransfers: PendingLineTransfer[];

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        return super.create<T>(data);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'pendingLineTransfers',
            model: PendingLineTransfer
        }];
    }
}
